export default "Some popular image and video diffusion models are:\n\n- **Midjourney**\n- and **Sora**\n"